module.exports = __webpack_public_path__ + "img/close.475e7fa6.svg";